module.exports = __webpack_public_path__ + "static/media/Ariados_gaussian2.32cf22ba.png";